export { default } from './RateTableCell';
